import sessions from "../../data/sessions"
import { AgendaSidebar } from "../AgendaSidebar"
import { optedIn } from "../../constants"

const openChatOnLoad = (name) => {
    if (!optedIn) return false;
    
    if (window.openChat) window.openChat(name)
    else setTimeout(() => {
        return openChatOnLoad(name)
    }, 1000)
}

const style = {
    position: "absolute",
    top: "2%",
    left: "82.3%",
    width: "16.7%",
    height: "85.2%",
    display: "flex",
    flexDirection: "column"
}

const title = {
    color: "rgb(60, 29, 74)",
    textAlign: "center",
    fontWeight: "bolder",
    fontFamily: "sans-serif",
    margin: "30px 0"
}

const stream = {
    position: "absolute",
    width: "62.1%",
    height: "70.4%",
    top: "5%",
    left: "19%"
}

export const body = {
    background: `https://assets.swoogo.com/uploads/full/2184701-636bb0a41b11b.jpg`,
    name: "Auditorium",
    inside: <>
        <div style={style}>
            <h1 style={title}>Auditorium</h1>
            <AgendaSidebar events={sessions} triggerAt={[[
                [new Date("2022-11-15 15:45:00 UTC"), new Date("2022-11-15 16:30:00 UTC")], () => {
                    setTimeout(() => {document.getElementById("IMB-consent").click() }, 1200)
                }
            ]]}/>
        </div>
        <iframe style={stream} onLoad={() => {
            //openChatOnLoad("Auditorium")
        }} id="ls_embed_1667297919" src="https://livestream.com/accounts/11603075/events/10668554/player?width=640&height=360&enableInfoAndActivity=false&defaultDrawer=&autoPlay=true&mute=false" allow="autoplay;" width="100%" height="auto" frameborder="0" scrolling="no" allowfullscreen> </iframe><script type="text/javascript" data-embed_id="ls_embed_1667297919" src="https://livestream.com/assets/plugins/referrer_tracking.js"></script>
    </>,
    links: [{
        width: "7.3%",
        height: "15.1%",
        left: "50.4%",
        top: "81.2%",
        label: "Please complete your feedback at the end of the session",
        isExternal: true,
        target: "_blank",
        href: "https://isfcongress.tkeventsregistration.com/feedbackmain"
    },
    {
        width: "7.3%",
        height: "15.1%",
        left: "42.5%",
        top: "81.2%",
        label: "Back to Atrium",
        isExternal: true,
        href: "/Atrium"
    }],
}

export const location = "/Auditorium"